import React from 'react';

const ProcessMinimal = () => {
  const steps = [
    {
      title: 'Discovery',
      description: 'Understanding your business model, audience dynamics, and growth objectives through structured conversation and data review'
    },
    {
      title: 'Strategy',
      description: 'Developing campaign architecture, creative direction, and measurement frameworks aligned with your specific goals'
    },
    {
      title: 'Launch',
      description: 'Implementing campaigns with attention to technical setup, testing protocols, and early performance indicators'
    },
    {
      title: 'Scale',
      description: 'Systematic optimization and expansion based on performance data, maintaining efficiency as spend increases'
    }
  ];

  return (
    <section className="bg-black border-y border-tertiary">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        {/* Section Label */}
        <div className="mb-16">
          <span className="text-sm text-tertiary font-sans uppercase tracking-wider">Process</span>
        </div>

        {/* Process Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {steps.map((step, index) => (
            <div key={step.title} className="space-y-4">
              {/* Step Number */}
              <div className="text-sm text-tertiary font-sans">
                0{index + 1}
              </div>

              {/* Step Title */}
              <h3 className="font-serif text-2xl text-gold">
                {step.title}
              </h3>

              {/* Step Description */}
              <p className="text-sm text-secondary font-sans leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessMinimal;
